module.exports = __webpack_public_path__ + "img/sphere10-graph-black.6169a1bc.png";